import { WSQueryCache } from "@ws-react-query";
import {
  FormDataPhoneNumber,
  phoneFormDataToE164
} from "../../modules/Onboarding/components/FormPartialPhoneNumber";
import {
  QUERY_USERS_ACCOUNT_MISSING_FIELDS,
  QUERY_USERS_MEMBER_PROFILE
} from "../../query/users/keys";
import {
  getCustomerEntity,
  updateCustomerData
} from "../../services/api/onboarding/customer";
import { usersService } from "../../services/users";

type EntityRequest = {
  firstName?: string;
  middleName?: string;
  lastName?: string;
  dateOfBirth?: Date;

  dba?: string;
  phone?: FormDataPhoneNumber;
  email?: string;
  website?: string;
  stateOfIncorporation?: string;

  address?: {
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    state?: string | null;
    postalCode?: string;
    country?: string | null;
  };
};

class EntityDataService {
  async updateEntity(
    data: EntityRequest,
    options?: {
      userId?: string;
    }
  ) {
    let hasEntity = false;
    try {
      await getCustomerEntity();
      hasEntity = true;
    } catch {
      hasEntity = false;
    }

    if (hasEntity) {
      await updateCustomerData("Entity", {
        customerData: {
          doingBusinessAs: data.dba || undefined,
          phoneNumber: data.phone ? phoneFormDataToE164(data.phone) : undefined,
          email: data.email || undefined,
          website: data.website || undefined,
          regionOfFormation: data.stateOfIncorporation || undefined,

          country: data.address?.country || undefined,
          addressLine1: data.address?.addressLine1 || undefined,
          addressLine2: data.address?.addressLine2 || null,
          city: data.address?.city || undefined,
          region: data.address?.state || undefined,
          postalCode: data.address?.postalCode || undefined
        }
      });
    } else if (options?.userId) {
      if (
        data.firstName ||
        data.middleName ||
        data.lastName ||
        data.dateOfBirth
      ) {
        await usersService.user.update(options.userId, {
          profile: {
            firstName: data.firstName || undefined,
            middleName: data.middleName || undefined,
            lastName: data.lastName || undefined,
            dob: data.dateOfBirth || undefined
          }
        });
      }

      if (
        data.address ||
        data.dba ||
        data.website ||
        data.stateOfIncorporation
      ) {
        await usersService.member.update(options.userId, {
          memberId: options.userId,
          profile: {
            company: {
              name: data.dba,
              website: data.website,
              stateOfIncorporation: data.stateOfIncorporation
            },
            address: {
              addressLine1: data.address?.addressLine1 || undefined,
              addressLine2: data.address?.addressLine2 || (null as any),
              city: data.address?.city || undefined,
              state: data.address?.state || undefined,
              postalCode: data.address?.postalCode || undefined,
              country: data.address?.country || "US"
            }
          }
        });
      }
    }

    if (options?.userId) {
      const userId = options.userId;

      const member = await usersService.member.get(userId);
      WSQueryCache.setQueryData(QUERY_USERS_MEMBER_PROFILE, member);
    }

    WSQueryCache.invalidateQueries(QUERY_USERS_ACCOUNT_MISSING_FIELDS);
  }
}

export const entityDataService = new EntityDataService();
